import api from 'api/direct-mail';
import handleResponse from './utils/handleResponse';

export const subscribeToAwsIot = () => {
    return handleResponse(
        api().get('/corporate/notifications/subscription')
    );
}